import { Box } from '@mui/material'
import { MRT_ColumnDef as MRTColumnDef } from 'material-react-table'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import MRTDataGridv2 from '../../../components/MRTDataGrid/MRTDataGridv2'
import EmbeddedContainer from '../components/EmbeddedContainer'
import { messages } from '../messages'
import { Destination, Journey, Leg } from '../types'
import { getAllUniqueLoadsForLeg } from '../utils'


type EmbeddedLegTableProps = {
    legs: Leg[]
    journey: Journey
}

const EmbeddedLegTable = ({ legs }: EmbeddedLegTableProps) => {
    const { formatMessage } = useIntl()

    const columns = useMemo<MRTColumnDef<Leg>[]>(() => {
        return [
            {
                accessorFn: (row) => {
                    return `Leg ${row.id}`
                },
                header: formatMessage(messages.legsName),
            },
            {
                accessorFn: (row) => {
                    return row.carrier?.name ?? ''
                },
                header: formatMessage(messages.carrierName),
            },
            {
                accessorFn: (row) => {
                    return row.routes.reduce((acc, route) => {
                        const orderedDestinations = [...(route.destinations ?? [])].sort(
                            (a: Destination, b: Destination) => {
                                const dateA = new Date(a.scheduledDate)
                                const dateB = new Date(b.scheduledDate)
                                return dateA.getTime() - dateB.getTime()
                            }
                        )

                        if (orderedDestinations.length === 0) {
                            const segment = `Route ${route.id}`
                            return acc === '' ? segment : `${acc}\n ${segment}`
                        }

                        const first = orderedDestinations[0]
                        const last = orderedDestinations[orderedDestinations.length - 1]

                        const fromName = first.location?.name ?? 'Unknown'
                        const toName = last.location?.name ?? 'Unknown'

                        const segment = `Route ${route.id} - (${fromName} > ${toName})`

                        return acc === '' ? segment : `${acc}\n ${segment}`
                    }, '')
                },
                header: formatMessage(messages.routesName),
            },
            {
                accessorFn: (row) => {
                    const uniqueLoads = getAllUniqueLoadsForLeg(row)

                    return uniqueLoads.reduce((acc, item) => {
                        if (acc === '') {
                            return `Load ${item.id.toString()}`
                        }
                        return acc + ` / Load ${item.id}`
                    }, '')
                },
                header: formatMessage(messages.loadsName)
            },
            {
                accessorFn: (row) => {
                    return row.status ?? ''
                },
                header: formatMessage(messages.statusName)
            }
        ]
    }, [])


    return (
        <EmbeddedContainer>
            <Box sx={{
                width: '100%',
                height: '100%',
            }}>
                <MRTDataGridv2
                    columns={columns}
                    data={legs || []}
                    enableColumnActions={false}
                    enableColumnFilters={false}
                    enablePagination={false}
                    enableSorting={false}
                    enableBottomToolbar={false}
                    enableTopToolbar={false}
                    positionActionsColumn='last'
                />
            </Box>

        </EmbeddedContainer>
    )
}

export default EmbeddedLegTable

